<template>
  <b-modal
      v-model="show"
      centered
      size="lg"
      modal-class="comment-modal"
      header-class="comment-modal__header"
      body-class="comment-modal__body"
      footer-class="comment-modal__footer"
      ok-only
      ok-title="بستن"
      hide-header-close
      @hidden="$emit('hidden')"
  >
    <template #modal-title>
      <div class="d-flex flex-column">
        <div class="comment-modal__title">جزئیات نظر</div>
        <div class="comment-modal__subtitle">نمایش اطلاعات نظر انتخاب شده</div>
      </div>
    </template>

    <div v-if="comment">
      <div class="view-head">
        <div class="view-head__left">
          <div class="avatar" :class="{ 'avatar--empty': !getAvatarUrl(comment) }">
            <img v-if="getAvatarUrl(comment)" :src="getAvatarUrl(comment)" alt="" />
            <span v-else>{{ getInitials(comment) }}</span>
          </div>

          <div class="view-head__meta">
            <div class="view-head__name">{{ getUserFullName(comment) }}</div>
            <div class="view-head__sub">
              <span>{{ formatDateTimeNoSeconds(comment.createDate) }}</span>
            </div>
          </div>
        </div>

        <div class="view-head__right">
          <b-badge :variant="comment.isConfirmed ? 'success' : 'danger'">
            {{ comment.isConfirmed ? "تایید شده" : "تایید نشده" }}
          </b-badge>
        </div>
      </div>

      <div class="chips-grid mt-3">
        <div class="detail-chip">
          <span class="detail-chip__label">نوع نظر</span>
          <span class="detail-chip__value">{{ getTypeLabel(comment.type) }}</span>
        </div>

        <div class="detail-chip">
          <span class="detail-chip__label">محصول</span>
          <span class="detail-chip__value">{{ getProductDisplay(comment) }}</span>
        </div>
      </div>

      <div class="section-card mt-3">
        <div class="section-card__title">متن نظر</div>
        <div class="section-card__body">
          <div v-if="String(comment.message || '').trim()" style="white-space:pre-wrap">
            {{ comment.message }}
          </div>
          <div v-else class="muted">متنی ثبت نشده.</div>
        </div>
      </div>

      <div class="section-card mt-3">
        <div class="section-card__title">مدیا</div>
        <div class="section-card__body">
          <div v-if="hasMedia(comment)" class="media-wrap">
            <img
                v-if="normalizedMediaType(comment.mediaType) === 2"
                :src="getContentUrl(comment)"
                class="media-preview"
                alt=""
            />

            <video
                v-else-if="normalizedMediaType(comment.mediaType) === 3"
                class="media-preview"
                controls
                :src="getContentUrl(comment)"
            ></video>

            <audio
                v-else-if="normalizedMediaType(comment.mediaType) === 4"
                class="w-100"
                controls
                :src="getContentUrl(comment)"
            ></audio>

            <div v-else>
              <b-link :href="getContentUrl(comment)" target="_blank">مشاهده فایل</b-link>
            </div>
          </div>

          <div v-else class="muted">مدیا ثبت نشده.</div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BBadge, BLink } from "bootstrap-vue";
import {
  formatDateTimeNoSeconds,
  getTypeLabel,
  getProductDisplay,
  normalizedMediaType,
  getContentUrl,
  hasMedia,
  getUserFullName,
  getAvatarUrl,
  getInitials,
} from "@/@core/utils/commentUtils";

export default {
  name: "CommentViewModal",
  components: { BModal, BBadge, BLink },
  props: {
    value: { type: Boolean, default: false }, // v-model
    comment: { type: Object, default: null },
  },
  computed: {
    show: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },
  },
  methods: {
    formatDateTimeNoSeconds,
    getTypeLabel,
    getProductDisplay,
    normalizedMediaType,
    getContentUrl,
    hasMedia,
    getUserFullName,
    getAvatarUrl,
    getInitials,
  },
};
</script>

<style scoped>
.comment-modal__header { border-bottom: 0; padding: 18px 22px 8px; }
.comment-modal__title { font-size: 18px; font-weight: 800; color: #111827; }
.comment-modal__subtitle { font-size: 12px; color: #6b7280; margin-top: 4px; }
.comment-modal__body { padding: 16px 22px 8px; }
.comment-modal__footer { border-top: 0; padding: 12px 22px 18px; }
.comment-modal :deep(.modal-content) {
  border: 0; border-radius: 14px;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.18);
}

.view-head {
  display: flex; align-items: center; justify-content: space-between;
  border: 1px solid #e5e7eb; border-radius: 14px;
  padding: 12px; background: #fafafa;
}
.view-head__left { display: flex; align-items: center; gap: 12px; }
.view-head__meta { display: flex; flex-direction: column; gap: 4px; }
.view-head__name { font-size: 14px; font-weight: 800; color: #111827; }
.view-head__sub { font-size: 12px; color: #6b7280; display:flex; align-items:center; flex-wrap:wrap; }
.view-head__right { display: flex; align-items: center; }

.avatar {
  width: 44px; height: 44px; border-radius: 999px;
  overflow: hidden; display:flex; align-items:center; justify-content:center;
  border: 1px solid #e5e7eb; background: white;
}
.avatar img { width: 100%; height: 100%; object-fit: cover; }
.avatar--empty { background: #eef2ff; color: #3730a3; font-weight: 800; }

.chips-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
@media (max-width: 768px) {
  .chips-grid { grid-template-columns: 1fr; }
}

.detail-chip {
  background: #f3f4f6; border-radius: 12px; padding: 10px 12px;
  display: flex; flex-direction: column; gap: 4px;
  border: 1px solid #e5e7eb;
}
.detail-chip__label { font-size: 11px; color: #6b7280; }
.detail-chip__value { font-size: 13px; font-weight: 800; color: #111827; }

.section-card {
  border: 1px solid #e5e7eb; border-radius: 14px;
  overflow: hidden; background: #fff;
}
.section-card__title {
  padding: 10px 12px; font-size: 13px; font-weight: 900;
  color: #111827; background: #f9fafb; border-bottom: 1px solid #e5e7eb;
}
.section-card__body { padding: 12px; font-size: 13px; color: #111827; }

.muted { color: #6b7280; font-size: 12px; }

.media-wrap {
  width: 100%;
  background: #0b1220;
  border-radius: 12px;
  padding: 10px;
}
.media-preview {
  width: 100%;
  max-height: 360px;
  border-radius: 10px;
  object-fit: contain;
  background: transparent;
}
</style>
